import React from "react";
import {AbsoluteFill, Sequence} from "remotion";
import {AnimatedTitle} from "../../components/text/AnimatedTitle";
import {GradientBackground} from "../../components/backgrounds/GradientBackground";
import {ParticleField} from "../../components/backgrounds/ParticleField";
import {SafeArea} from "../../components/layout/SafeArea";
import {Watermark} from "../../components/overlays/Watermark";
import {loadDefaultFonts} from "../../presets/fonts";
import {BRAND} from "../../presets/brand";
import {OrganicLayer} from "../../components/overlays/OrganicLayer";
import {FilmGrain as CinemaGrain, CinemaVignette} from "../../components/overlays/FilmGrain";

export interface YouTubeShortProps {
  title?: string;
  subtitle?: string;
  backgroundColors?: string[];
  accentColor?: string;
}

export const YouTubeShort: React.FC<YouTubeShortProps> = ({
  title = "Your Title Here",
  subtitle,
  backgroundColors = ["#0c1222", "#162032"],
  accentColor = "#ef4444",
}) => {
  loadDefaultFonts();

  return (
    <OrganicLayer intensity="subtle" seed="youtube">
    <AbsoluteFill>
      <GradientBackground colors={backgroundColors} angle={180} />
      <ParticleField count={30} color="rgba(255,255,255,0.1)" speed={0.5} />

      <SafeArea paddingHorizontal={60} paddingVertical={200}>
        <Sequence from={0}>
          <AbsoluteFill style={{justifyContent: "center", alignItems: "center"}}>
            <AnimatedTitle
              text={title}
              fontSize={60}
              fontWeight={900}
              color="#ffffff"
              enterAnimation="scale"
              enterDuration={20}
              holdDuration={999}
              exitDuration={0}
              textShadow={`0 4px 20px ${accentColor}50`}
            />
            {subtitle && (
              <div style={{marginTop: 20}}>
                <AnimatedTitle
                  text={subtitle}
                  fontSize={30}
                  fontWeight={400}
                  color="rgba(255,255,255,0.7)"
                  enterAnimation="slideUp"
                  enterDuration={25}
                  holdDuration={999}
                  exitDuration={0}
                />
              </div>
            )}
          </AbsoluteFill>
        </Sequence>
      </SafeArea>

      <Watermark text={BRAND.handle} corner="topRight" opacity={0.5} fontSize={14} color="#ffffff" margin={40} />
      <CinemaGrain opacity={0.06} />
      <CinemaVignette opacity={0.5} />
    </AbsoluteFill>
    </OrganicLayer>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
